
import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Plus, ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTasks } from '@/hooks/useTasks'

const DashboardTasksCard = () => {
  const navigate = useNavigate()
  const { getMyTasks } = useTasks()

  // Get the tasks object and extract both arrays
  const myTasks = getMyTasks()
  const { userTasks, customTasks } = myTasks

  // Combine and transform tasks into a consistent format for sorting
  const allTasks = [
    ...userTasks.map(ut => ({
      id: ut.id,
      title: ut.school_tasks.title,
      module: ut.school_tasks.module,
      priority: ut.school_tasks.priority,
      created_at: (ut as any).created_at || new Date().toISOString() // Fallback for missing created_at
    })),
    ...customTasks.map(ct => ({
      id: ct.id,
      title: ct.title,
      module: ct.module,
      priority: false,
      created_at: (ct as any).created_at || new Date().toISOString() // Fallback for missing created_at
    }))
  ]

  // Get the 3 most recent tasks
  const recentTasks = allTasks
    .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
    .slice(0, 3)

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 flex-shrink-0">
        <CardTitle className="text-base font-medium">My Tasks</CardTitle>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/tasks')}
          className="h-8 px-2"
        >
          <ArrowRight className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col">
        <div className="space-y-2 flex-1">
          {recentTasks.length > 0 ? (
            recentTasks.map((task) => (
              <div key={task.id} className="flex items-center justify-between p-2 rounded-lg bg-gray-50">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    {task.priority && (
                      <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                    )}
                    <p className="text-sm font-medium text-gray-900 break-words leading-relaxed">{task.title}</p>
                  </div>
                  <p className="text-xs text-gray-600">{task.module || 'General'}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-8 text-center">
              <p className="text-sm text-gray-500 mb-4">No tasks yet</p>
            </div>
          )}
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          className="w-full mt-3 flex-shrink-0"
          onClick={() => navigate('/tasks')}
        >
          <Plus className="w-4 h-4 mr-2" />
          View All Tasks
        </Button>
      </CardContent>
    </Card>
  )
}

export default DashboardTasksCard
